module.exports = __webpack_public_path__ + "static/img/2-3.6f60bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/2-3.png
// module id = KY2c
// module chunks = 0